import React, { useEffect } from 'react'
import Spacing from '../../../componenets/UI/Spacing'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaLocationArrow, FaPhone, FaSnapchatGhost, FaVoicemail, FaYoutube } from 'react-icons/fa'
import { FaLinkedin, FaLocationDot, FaXTwitter } from 'react-icons/fa6'
import { MdEmail } from 'react-icons/md'
import { TbWorldWww } from 'react-icons/tb'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import useSponsorsActions from '../hooks/useSponsorsActions'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import LoaderSponsorDetailsPage from '../components/sponsor-details-page/LoaderSponsorDetailsPage'

export default function SponsorDetailsPage() {
  const { t } = useTranslation()
  const { lng } = useParams()
  const { sponsor_slug } = useParams()
  const { getSponsor } = useSponsorsActions()
  const { sponsorState } = useSponsorContext()

  useEffect(() => {
    getSponsor(sponsor_slug)
  }, [sponsor_slug])

  if (sponsorState.isLoading) {
    return <LoaderSponsorDetailsPage />
  }
  return (
    <div className="app-container px-8 lg:px-0">
      <Helmet>
        <title>{`APFM | ${t('SPONSOR_DIAMOND')} : ${sponsorState.sponsor[`name_${lng}`]}`}</title>
      </Helmet>
      <Spacing />
      <div
        data-aos={`fade-down`}
        data-aos-delay={100}
        className="mb-4"
      >
        <h2 className="text-2xl font-black">{t('SPONSOR_DIAMOND')}</h2>
      </div>
      <div
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div>
          <div className="mb-16 flex flex-col border-2 border-muted-300 bg-light p-8 lg:flex-row">
            <div className="lg:ltr:border-r-2 lg:ltr:pr-8 lg:rtl:border-l-2 lg:rtl:pl-8">
              <img
                className="!h-64 !w-64 object-cover"
                src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsorState.sponsor.logo}`}
                alt={sponsorState.sponsor[`name_${lng}`]}
              />
            </div>
            <div className="lg:px-8">
              <h2 className="mb-8 text-3xl font-bold">{sponsorState.sponsor[`name_${lng}`]}</h2>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div>
                    <FaLocationDot />
                  </div>
                  <div>{sponsorState.sponsor.country[`name_${lng}`] ?? '--'}</div>
                </div>
                <div className="flex items-center gap-2">
                  <div>
                    <FaPhone />
                  </div>
                  <div dir="ltr">{sponsorState.sponsor.phone ?? '--'}</div>
                </div>
                <div className="flex items-center gap-2">
                  <div>
                    <MdEmail />
                  </div>
                  <div>{sponsorState.sponsor.email ?? '--'}</div>
                </div>
                <div className="flex items-center gap-2">
                  <div>
                    <TbWorldWww />
                  </div>
                  <Link
                    target="_blank"
                    to={sponsorState.sponsor.website_url}
                  >
                    {sponsorState.sponsor.website_url}
                  </Link>
                </div>
              </div>
              <div className="mt-8 flex gap-2">
                {sponsorState.sponsor.linkedin && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.linkedin}
                  >
                    <FaLinkedinIn />
                  </Link>
                )}
                {sponsorState.sponsor.x && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.x}
                  >
                    <FaXTwitter />
                  </Link>
                )}
                {sponsorState.sponsor.youtube && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.youtube}
                  >
                    <FaYoutube />
                  </Link>
                )}
                {sponsorState.sponsor.facebook && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.facebook}
                  >
                    <FaFacebookF />
                  </Link>
                )}
                {sponsorState.sponsor.snapchat && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.snapchat}
                  >
                    <FaSnapchatGhost />
                  </Link>
                )}
                {sponsorState.sponsor.instagram && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsorState.sponsor.instagram}
                  >
                    <FaInstagram />
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div>
            <h2 className="mb-4 text-2xl font-bold">{t('DESCRIPTION')}</h2>
            <article>
              <p
                className="text-justify"
                dangerouslySetInnerHTML={{
                  __html: sponsorState.sponsor[`description_${lng}`],
                }}
              />
            </article>
          </div>
        </div>
      </div>
    </div>
  )
}
